import { ROUTES } from "../routes";

export const extractOrganizationId = (path: string): string | null => {
  const orgIdRegex = /^\/organizations\/([^/]+)/;
  const match = path.match(orgIdRegex);
  return match ? match[1] : null;
};

export const getHomeRoute = (): string => {
  const orgId = extractOrganizationId(window.location.pathname);
  return orgId
    ? `${ROUTES.ORGANIZATIONS}/${orgId}/${ROUTES.CHATS}`
    : ROUTES.ORGANIZATIONS;
};
